module.exports = __webpack_public_path__ + "fonts/NotoSans-SemiBold.3334e73.ttf";